import { IProjectLoanPurpose } from '~/@api/generated-api-types-project/Api'
import type { ObjectValues } from '~/@lib/utils/type.utils'

export const ProjectLoanPurpose = {
  Business: IProjectLoanPurpose.Business,
  Buying: IProjectLoanPurpose.Buying,
  Construction: IProjectLoanPurpose.Construction,
  Development: IProjectLoanPurpose.Development,
  Investment: IProjectLoanPurpose.Investment,
  Purchase: IProjectLoanPurpose.Purchase,
  Reconstruction: IProjectLoanPurpose.Reconstruction,
  Refinancing: IProjectLoanPurpose.Refinancing,
} as const

export type ProjectLoanPurpose = ObjectValues<typeof ProjectLoanPurpose>
